import { render, staticRenderFns } from "./GdprInput.vue?vue&type=template&id=1f4d7888&"
import script from "./GdprInput.vue?vue&type=script&lang=js&"
export * from "./GdprInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports